import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    // [types.SET_SETTINGS]: (state, items) => Vue.set(state, 'items', items),
    [types.SET_SETTINGS]: (state, items) => state.items = items,
    [types.ADD_OR_UPDATE_SETTING]: (state, item) => addOrUpdateItem(state, item),
}